import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ProjectUsers = lazy(
  () => import("@/features/projects/project/users/index.tsx"),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/projects/$projectId/users",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ProjectUsers />
    </Suspense>
  );
}
